import { CommonModule } from '@angular/common'
import { Component, input } from '@angular/core'
@Component({
  selector: 'nc-banner',
  template: ` <div
    [class]="class()"
    [ngClass]="{
      ncBanner: true,
      ncBanner___defaultBottomMargin: this.bottomMargin(),
      ncBanner___defaultTopMargin: this.topMargin(),
      ncBanner___centered: this.centered(),
      ncBanner___gradient: this.gradient(),
      ncBanner___test366: this.isTest366(),
    }"
  >
    <div class="ncBanner__content" [innerHTML]="text()"></div>
  </div>`,
  imports: [CommonModule],
  styleUrls: ['./nc-banner.component.scss'],
})
export class NCBannerComponent {
  public class = input('')
  public text = input('')
  public centered = input(false)
  public bottomMargin = input(false)
  public topMargin = input(false)
  public gradient = input(false)
  public isTest366 = input(false)
}
